"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransmissionMethodKeysEnumForSirV1 = void 0;
const actions_1 = require("../../../models/actions");
var TransmissionMethodKeysEnumForSirV1;
(function (TransmissionMethodKeysEnumForSirV1) {
    TransmissionMethodKeysEnumForSirV1["FileTransfer"] = "fileTransfer";
    TransmissionMethodKeysEnumForSirV1["Email"] = "email";
    TransmissionMethodKeysEnumForSirV1["SiteFlow"] = "siteFlow";
    TransmissionMethodKeysEnumForSirV1["EnfocusSwitch"] = "enfocusSwitch";
    TransmissionMethodKeysEnumForSirV1["PromoStandards"] = "promoStandards";
    TransmissionMethodKeysEnumForSirV1["ApiPoll"] = "apiPoll";
    TransmissionMethodKeysEnumForSirV1["ApiPush"] = "apiPush";
    TransmissionMethodKeysEnumForSirV1["Pom"] = "pom";
    // Additional keys
    TransmissionMethodKeysEnumForSirV1["Api"] = "api";
})(TransmissionMethodKeysEnumForSirV1 = exports.TransmissionMethodKeysEnumForSirV1 || (exports.TransmissionMethodKeysEnumForSirV1 = {}));
